import {Environment} from '../environment';
import {PROXY_PORTS} from './constants';
import {HttpUrl} from './types';

const urls: Record<Environment, HttpUrl> = {
  production: 'https://tadarida-rest.aboutyou.com',
  preview: 'https://tadarida-preview-rest.aboutyou.com',
  staging: 'https://tadarida-rest.aboutyou-staging.com',
  development: `http://localhost:${PROXY_PORTS.TADARIDA_REST_PORT}` as HttpUrl,
};
export const getTadaridaRestUrlByEnvironment = (env: Environment): HttpUrl => {
  return urls[env];
};
